:host {
  display: block;
}

:host([style-selection='basic']) {
  border-bottom: 1px solid var(--color-neutral-light);
}

:host([style-selection='pattern']) {
  height: 12px;
  background-position: -6px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAARklEQVQoU2NkwALWesz5DxMO3pHCCGKDCWSATRGGQlyKUBTiUwRXSEgRWCExilAUwnyHKxTAJhJShDV4cAUVRjjCFKK7HQBy0Cu7Zebb2wAAAABJRU5ErkJggg==);
}

:host([style-selection='pattern-alt-1']) {
  height: 12px;
  background-position: -6px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAMAAAC67D+PAAAABlBMVEUApVEAAABuEcHuAAAAAnRSTlP/AOW3MEoAAAAmSURBVAiZY2AEAQYGBiABZ4GZEBaICWUBmTAWiAFlMRJkIbQwAgAPeABHZVGLJgAAAABJRU5ErkJggg==);
}
